export default __webpack_public_path__ + "static/media/T564_RoHS.d469b6c0.pdf";